import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "active-filter__item-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "active-filter__item-close" }, null, -1)
const _hoisted_4 = { class: "active-filter__item-label" }
const _hoisted_5 = {
  key: 0,
  class: "active-filter__item-title"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "active-filter__item-close" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type == 'list')
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(_ctx.invalid ? 'active-filter__item active-filter__item-invalid' : 'active-filter__item'),
          key: item,
          onClick: ($event: any) => (_ctx.removeActiveFilter(_ctx.group, _ctx.name, item.toString()))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(item.toString() == "Pick-up" ? "Pickup" : item.toString()), 1),
          _hoisted_3
        ], 10, _hoisted_1))
      }), 128))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.invalid ? 'active-filter__item active-filter__item-invalid' : 'active-filter__item'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeActiveFilter(_ctx.group, _ctx.name, _ctx.value.toString())))
      }, [
        _createElementVNode("span", _hoisted_4, [
          (_ctx.type == 'range')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.title) + " : ", 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.formatContent()), 1)
        ]),
        _hoisted_6
      ], 2))
}